import axios, { AxiosError, InternalAxiosRequestConfig } from "axios";

export const apiClient = axios.create({
  withCredentials: false,
  baseURL: "https://api.exagonplus.com/v1/mp/",
  headers: {
    Authorization: import.meta.env.VITE_REACT_APP_IDENTIFIER,
    "Content-Type": "application/json",
  },
});

// API Client V2 with specific headers for social hub
export const apiClientV2 = axios.create({
  withCredentials: false,
  baseURL: "https://api.exagonplus.com/v2/",
  headers: {
    "X-App-Id": "social_hub",
    "X-Organization-Id": "exagon",
    "X-Timezone": "Europe/Rome",
    "Content-Type": "application/json",
  },
});

// Request interceptor to add JWT token to Authorization header
apiClientV2.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    // Get jwt_token from localStorage
    const storedData = localStorage.getItem('shu');
    if (storedData) {
      try {
        const parsedData = JSON.parse(storedData);
        const jwtToken = parsedData?.state?.jwt_token;
        
        if (jwtToken && config.headers) {
          config.headers.Authorization = `Bearer ${jwtToken}`;
          console.log('🔐 JWT Token aggiunto alla richiesta:', config.url);
        }
      } catch (error) {
        console.error('❌ Error parsing stored data:', error);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Defining a custom error handler for all APIs
const errorHandler = (error: AxiosError) => {
  const statusCode = error.response?.status;
  console.log(statusCode, error.response?.data);

  return Promise.reject(error);
};

apiClient.interceptors.response.use(undefined, (error: AxiosError) => {
  return errorHandler(error);
});

apiClientV2.interceptors.response.use(undefined, (error: AxiosError) => {
  return errorHandler(error);
});
